// Course content opens in a new tab (see `targetForHref` in AppNavigationContainer), so the
// in-memory/sessionStorage navigation history doesn't carry over: on returning from the course
// player, the course's home screen has no way of knowing it was opened from a learning track.
// localStorage IS shared across tabs of the same origin, so we use it to remember, per course,
// which learning track it was last opened from.

export interface BeWizrLearningTrackReturnContext {
  id:    string
  title: string
}

function storageKey(courseSlug: string) {
  return `bewizr:course:${courseSlug}:learning-track`
}

export function rememberLearningTrackForCourse(courseSlug: string, context: BeWizrLearningTrackReturnContext) {
  try {
    localStorage.setItem(storageKey(courseSlug), JSON.stringify(context))
  } catch {
    // Storage unavailable (e.g. disabled or full) - not remembering the context is a graceful degradation.
  }
}

export function recallLearningTrackForCourse(courseSlug: string): BeWizrLearningTrackReturnContext | null {
  try {
    const raw = localStorage.getItem(storageKey(courseSlug))
    return raw == null ? null : JSON.parse(raw)
  } catch {
    return null
  }
}
